import React, { useState } from 'react'
import { useRoleConflict } from 'api/hooks/use-role-conflicts'
import Table from 'react-bootstrap/Table'
import TableLoading from 'shared/tables/table-loading'
import ChangePermission from 'duties/roles/ChangePermission'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFolder } from '@fortawesome/free-solid-svg-icons'

function ConflictDetails({ role, analytic, isActive }) {
  const [show, setShow] = useState(false)
  const [permissionId, setPermissionId] = useState('')
  const params = {
    role_id: role.id,
    analytic_id: analytic.id
  }
  const options = {
    enabled: isActive
  }

  const { isSuccess, isLoading, data } = useRoleConflict({ params, options })

  const grouped = isSuccess
    ? data.conflicts.reduce((acc, conflict) => {
        const key = `${conflict.role}-${conflict.conflict_role}`

        if (!acc[key]) {
          acc[key] = {
            role: conflict.role,
            conflict_role: conflict.conflict_role,
            permissions: []
          }
        }

        acc[key].permissions.push({
          permission_id: conflict.permission_id,
          permission: conflict.permission,
          permission_description: conflict.permission_description,
          permission_category_caption: conflict.permission_category_caption,
          conflict_permission_id: conflict.conflict_permission_id,
          conflict_permission: conflict.conflict_permission,
          conflict_permission_description:
            conflict.conflict_permission_description,
          conflict_permission_category_caption:
            conflict.conflict_permission_category_caption
        })

        return acc
      }, {})
    : []

  // Convert the grouped object back into an array for easy rendering
  const groupedArray = Object.values(grouped)

  const [hoveredPermission, setHoveredPermission] = useState(null)

  return (
    <div>
      <Table
        className="border-light border bg-white shadow-sm"
        responsive
        size="sm"
      >
        <thead>
          <tr>
            <th>Permission</th>
            <th>Conflicting Permission</th>
          </tr>
        </thead>
        <tbody>
          {isLoading && <TableLoading columns={3} />}
          {isSuccess &&
            groupedArray.map((group) => (
              <React.Fragment key={`${group.role}-${group.conflict_role}`}>
                {group.permissions.map((permission, index) => (
                  <tr key={`${group.role}-${group.conflict_role}-${index}`}>
                    <td
                      className={`text-muted ${
                        hoveredPermission === permission.permission_id
                          ? 'text-decoration-underline  bg-light'
                          : ''
                      }`}
                      style={{
                        cursor: 'pointer'
                      }}
                      onMouseEnter={() =>
                        setHoveredPermission(permission.permission_id)
                      }
                      onMouseLeave={() => setHoveredPermission(null)}
                      onClick={() => {
                        setShow(true)
                        setPermissionId(permission.permission_id)
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faFolder}
                        className="me-2 text-muted"
                      />
                      {permission.permission_category_caption}:{' '}
                      {permission.permission_description} (
                      {permission.permission})
                    </td>
                    <td
                      className={`text-muted ${
                        hoveredPermission === permission.conflict_permission_id
                          ? 'text-decoration-underline bg-light'
                          : ''
                      }`}
                      style={{
                        cursor: 'pointer'
                      }}
                      onMouseEnter={() =>
                        setHoveredPermission(permission.conflict_permission_id)
                      }
                      onMouseLeave={() => setHoveredPermission(null)}
                      onClick={() => {
                        setShow(true)
                        setPermissionId(permission.conflict_permission_id)
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faFolder}
                        className="me-2 text-muted"
                      />
                      {permission.conflict_permission_category_caption}:{' '}
                      {permission.conflict_permission_description} (
                      {permission.conflict_permission})
                    </td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
        </tbody>
        {permissionId !== '' && permissionId !== undefined && (
          <ChangePermission
            setShow={setShow}
            show={show}
            role={role}
            roleId={role.id}
            permissionId={permissionId}
          />
        )}
      </Table>
    </div>
  )
}

export default ConflictDetails
